<div class="sidenav-menu">
  @if (logoReady && showCompanyLogo && companyLogoUrl) {
    <div class="d-flex align-items-center justify-content-center py-3">
      <img
        [src]="companyLogoUrl"
        alt="Company logo"
        style="max-height: 48px; max-width: 160px; object-fit: contain;"
      />
    </div>
  } @else if (logoReady) {
    <app-logo-box />
  }

  <button class="button-sm-hover" (click)="changeSidebarSize()">
    <i class="ri-circle-line align-middle"></i>
  </button>

  <button class="sidenav-toggle-button" (click)="onToggleMobileMenu()">
    <i class="ri-menu-5-line fs-20"></i>
  </button>

  <button class="button-close-fullsidebar" (click)="onToggleMobileMenu()">
    <i class="ti ti-x align-middle"></i>
  </button>
  <ngx-simplebar data-simplebar>
    <!-- User -->
    <!-- <div class="sidenav-user">
      <div class="dropdown-center text-center" ngbDropdown>
        <a
          class="topbar-link dropdown-toggle text-reset drop-arrow-none px-2"
          ngbDropdownToggle
          data-bs-toggle="dropdown"
          type="button"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <i class="ti ti-user-circle fs-36"></i>
          <span class="d-flex gap-1 sidenav-user-name my-2">
            <span>
              <span class="mb-0 fw-semibold lh-base fs-15">{{
                user?.name
              }}</span>
            </span>

            <i
              class="ri-arrow-down-s-line d-block sidenav-user-arrow align-middle"
            ></i>
          </span>
        </a>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">{{ "Welcome !" | translate }}</h6>
          </div>

          <a href="javascript:void(0);" class="dropdown-item">
            <i class="ri-account-circle-line me-1 fs-16 align-middle"></i>
            <span class="align-middle">My Account</span>
          </a>

          <a href="javascript:void(0);" class="dropdown-item">
            <i class="ri-wallet-3-line me-1 fs-16 align-middle"></i>
            <span class="align-middle"
              >Wallet : <span class="fw-semibold">$89.25k</span></span
            >
          </a>

          <a href="javascript:void(0);" class="dropdown-item">
            <i class="ri-settings-2-line me-1 fs-16 align-middle"></i>
            <span class="align-middle">Settings</span>
          </a>

          <a
            (click)="changePassword()"
            href="javascript:void(0);"
            class="dropdown-item"
          >
            <i class="ti ti-password-user me-1 fs-16 align-middle"></i>
            <span class="align-middle">{{
              "Change Password" | translate
            }}</span>
          </a>

          <div class="dropdown-divider"></div>

          <a href="javascript:void(0);" class="dropdown-item">
            <i class="ri-lock-line me-1 fs-16 align-middle"></i>
            <span class="align-middle">Lock Screen</span>
          </a>

          <a
            (click)="logout()"
            href="javascript:void(0);"
            class="dropdown-item active fw-semibold text-danger"
          >
            <i class="ri-logout-box-line me-1 fs-16 align-middle"></i>
            <span class="align-middle">{{ "Sign Out" | translate }}</span>
          </a>
        </div>
      </div>
    </div> -->
    @if (loadingMenu) {
      <div class="d-flex flex-column align-items-center justify-content-center py-5">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted small mb-0">Loading menu...</p>
      </div>
    } @else {
      <ul class="side-nav">
        @for (item of menuItems; track item.key; let first = $first) { @if
        (!item.isSuperAdmin || user?.type == 1) { @if(item.isTitle){
        <li class="side-nav-title">{{ item.label }}</li>
        }@else { @if (hasSubmenu(item)) {
        <ng-container
          *ngTemplateOutlet="
            MenuItemWithChildren;
            context: {
              menu: item,
              linkClassName: 'side-nav-link nav-link-ref',
              subMenuClassNames: 'sub-menu',
              itemClassName: 'side-nav-item'
            }
          "
        >
        </ng-container>
        }@else {
        <ng-container
          *ngTemplateOutlet="
            MenuItem;
            context: {
              menu: item,
              linkClassName: 'side-nav-link nav-link-ref',
              itemClassName: 'side-nav-item'
            }
          "
        >
        </ng-container>
        } } } }
      </ul>
    }

    <div class="clearfix"></div>
  </ngx-simplebar>
</div>

<ng-template
  #MenuItemWithChildren
  let-menu="menu"
  let-itemClassName="itemClassName"
  let-linkClassName="linkClassName"
  let-subMenuClassNames="subMenuClassNames"
>
  <li
    [class]="itemClassName"
    [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
  >
    <a
      [class]="linkClassName"
      [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
      (click)="toggleMenuItem(menu, collapse)"
      role="button"
      [attr.aria-expanded]="!menu.collapsed"
      aria-controls="sidebarDashboards"
      [attr.aria-controls]="menu.key"
    >
      @if (menu.icon) {
      <span class="menu-icon">
        <i class="ti {{ menu.icon }}"></i>
      </span>
      }
      <span class="menu-text"> {{ menu.label }} </span>
      <span class="menu-arrow"></span>
    </a>
    <div
      #collapse="ngbCollapse"
      [(ngbCollapse)]="menu.collapsed"
      class="collapse"
      id="sidebarDashboards"
    >
      <ul [class]="subMenuClassNames">
        @for (child of menu.children; track child.label) { @if
        (!child.isSuperAdmin || user?.type == 1) { @if (hasSubmenu(child)) {
        <ng-container
          *ngTemplateOutlet="
            MenuItemWithChildren;
            context: {
              menu: child,
              linkClassName: 'side-nav-link nav-link-ref',
              itemClassName: 'side-nav-item',
              subMenuClassNames: 'sub-menu'
            }
          "
        >
        </ng-container>
        } @else {
        <ng-container
          *ngTemplateOutlet="
            MenuItem;
            context: {
              menu: child,
              linkClassName: 'side-nav-link nav-link-ref',
              itemClassName: 'side-nav-item'
            }
          "
        >
        </ng-container>
        } } }
      </ul>
    </div>
  </li>
</ng-template>

<ng-template
  #MenuItem
  let-menu="menu"
  let-linkClassName="linkClassName"
  let-itemClassName="itemClassName"
>
  <li
    [class]="itemClassName"
    [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
  >
    <ng-container
      *ngTemplateOutlet="
        MenuItemLink;
        context: { menu: menu, className: linkClassName }
      "
    >
    </ng-container>
  </li>
</ng-template>

<ng-template #MenuItemLink let-menu="menu" let-className="className">
  <a
    [routerLink]="menu.url"
    [queryParams]="menu.queryParams"
    [class]="className"
    [ngClass]="{
      active: activeMenuItems.includes(menu.key),
      disabled: menu.isDisabled
    }"
    [attr.aria-controls]="menu.key"
  >
    @if (menu.icon) {
    <span class="menu-icon">
      <i class="{{ menu.icon }}"></i>
    </span>
    <span class="menu-text">{{ menu.label }}</span>
    } @else {
    {{ menu.label }}
    } @if (menu.badge) {
    <span class="badge rounded-pill text-end bg-{{ menu.badge.variant }}">{{
      menu.badge.text
    }}</span>
    }
  </a>
</ng-template>
